/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.8
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ProjectTraitsSetDTO } from './ProjectTraitsSetDTO';
import {
    ProjectTraitsSetDTOFromJSON,
    ProjectTraitsSetDTOFromJSONTyped,
    ProjectTraitsSetDTOToJSON,
} from './ProjectTraitsSetDTO';
import type { ProjectVisibilityDTO } from './ProjectVisibilityDTO';
import {
    ProjectVisibilityDTOFromJSON,
    ProjectVisibilityDTOFromJSONTyped,
    ProjectVisibilityDTOToJSON,
} from './ProjectVisibilityDTO';
import type { OrganizationTypeDTO } from './OrganizationTypeDTO';
import {
    OrganizationTypeDTOFromJSON,
    OrganizationTypeDTOFromJSONTyped,
    OrganizationTypeDTOToJSON,
} from './OrganizationTypeDTO';

/**
 * 
 * @export
 * @interface ProjectMetadataDTO
 */
export interface ProjectMetadataDTO {
    /**
     * 
     * @type {string}
     * @memberof ProjectMetadataDTO
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectMetadataDTO
     */
    organizationId: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectMetadataDTO
     */
    projectKey: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectMetadataDTO
     */
    name: string;
    /**
     * 
     * @type {Date}
     * @memberof ProjectMetadataDTO
     */
    timeOfCreation: Date;
    /**
     * 
     * @type {string}
     * @memberof ProjectMetadataDTO
     */
    organizationName: string;
    /**
     * 
     * @type {OrganizationTypeDTO}
     * @memberof ProjectMetadataDTO
     */
    organizationType: OrganizationTypeDTO;
    /**
     * 
     * @type {number}
     * @memberof ProjectMetadataDTO
     */
    version: number;
    /**
     * 
     * @type {ProjectVisibilityDTO}
     * @memberof ProjectMetadataDTO
     */
    visibility: ProjectVisibilityDTO;
    /**
     * 
     * @type {number}
     * @memberof ProjectMetadataDTO
     */
    storageUsage: number;
    /**
     * 
     * @type {boolean}
     * @memberof ProjectMetadataDTO
     */
    archived: boolean;
    /**
     * 
     * @type {ProjectTraitsSetDTO}
     * @memberof ProjectMetadataDTO
     */
    traits: ProjectTraitsSetDTO;
}



/**
 * Check if a given object implements the ProjectMetadataDTO interface.
 */
export function instanceOfProjectMetadataDTO(value: object): value is ProjectMetadataDTO {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('organizationId' in value) || value['organizationId'] === undefined) return false;
    if (!('projectKey' in value) || value['projectKey'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('timeOfCreation' in value) || value['timeOfCreation'] === undefined) return false;
    if (!('organizationName' in value) || value['organizationName'] === undefined) return false;
    if (!('organizationType' in value) || value['organizationType'] === undefined) return false;
    if (!('version' in value) || value['version'] === undefined) return false;
    if (!('visibility' in value) || value['visibility'] === undefined) return false;
    if (!('storageUsage' in value) || value['storageUsage'] === undefined) return false;
    if (!('archived' in value) || value['archived'] === undefined) return false;
    if (!('traits' in value) || value['traits'] === undefined) return false;
    return true;
}

export function ProjectMetadataDTOFromJSON(json: any): ProjectMetadataDTO {
    return ProjectMetadataDTOFromJSONTyped(json, false);
}

export function ProjectMetadataDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectMetadataDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'organizationId': json['organizationId'],
        'projectKey': json['projectKey'],
        'name': json['name'],
        'timeOfCreation': (new Date(json['timeOfCreation'])),
        'organizationName': json['organizationName'],
        'organizationType': OrganizationTypeDTOFromJSON(json['organizationType']),
        'version': json['version'],
        'visibility': ProjectVisibilityDTOFromJSON(json['visibility']),
        'storageUsage': json['storageUsage'],
        'archived': json['archived'],
        'traits': ProjectTraitsSetDTOFromJSON(json['traits']),
    };
}

export function ProjectMetadataDTOToJSON(value?: ProjectMetadataDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'organizationId': value['organizationId'],
        'projectKey': value['projectKey'],
        'name': value['name'],
        'timeOfCreation': ((value['timeOfCreation']).toISOString()),
        'organizationName': value['organizationName'],
        'organizationType': OrganizationTypeDTOToJSON(value['organizationType']),
        'version': value['version'],
        'visibility': ProjectVisibilityDTOToJSON(value['visibility']),
        'storageUsage': value['storageUsage'],
        'archived': value['archived'],
        'traits': ProjectTraitsSetDTOToJSON(value['traits']),
    };
}

